import li from 'parse-link-header';
import * as Constants from "./Constants.mjs";
import { patchResponseBody } from "./helpers/fetchToStream.mjs";
import { stripContentTypeParameters } from "./mediaType.mjs";
export default class {
  constructor(requestedUri, xhr, parsers, jsonLdContext) {
    this.requestedUri = requestedUri;
    this.xhr = xhr;
    this.parsers = parsers;
    this.jsonLdContext = jsonLdContext;
  }

  quadStream() {
    const quadStream = this.parsers.import(stripContentTypeParameters(this.mediaType), patchResponseBody(this.xhr), {
      baseIRI: this.effectiveUri,
      context: this.jsonLdContext
    });

    if (quadStream == null) {
      return null;
    }

    return quadStream;
  }

  get status() {
    return this.xhr.status;
  }

  get apiDocumentationLink() {
    if (this.xhr.headers.has(Constants.Headers.Link)) {
      if (this.links[Constants.LinkRelations.apiDocumentation]) {
        const linkUrl = this.links[Constants.LinkRelations.apiDocumentation].url;
        return this.resolveUri(linkUrl);
      }
    }

    return null;
  }

  get links() {
    const linkHeaders = this.xhr.headers.get(Constants.Headers.Link) || '';
    return li(linkHeaders) || {};
  }

  get mediaType() {
    if (this.links[Constants.LinkRelations.context]) {
      return 'application/ld+json';
    }

    return this.xhr.headers.get(Constants.Headers.ContentType) || '';
  }

  get redirectUrl() {
    if (this.xhr.redirected) {
      return this.xhr.url;
    }

    return null;
  }

  get effectiveUri() {
    return this.redirectUrl || this.xhr.url;
  }

  get resourceUri() {
    return this.createdResourceUri || this.canonicalUri || this.effectiveUri;
  }

  get createdResourceUri() {
    const location = this.xhr.headers.get(Constants.Headers.Location);

    if (this.xhr.status === 201 && location !== null) {
      return this.resolveUri(location);
    }

    return undefined;
  }

  get canonicalUri() {
    if (this.links[Constants.LinkRelations.canonical]) {
      return this.resolveUri(this.links[Constants.LinkRelations.canonical].url);
    }

    return undefined;
  }

  resolveUri(uri) {
    return new URL(uri, this.effectiveUri).toString();
  }

}